<wr-generic-pick-list [behaviour]="this" [(ngModel)]="value" [disabled]="isDisabled">
</wr-generic-pick-list>
